class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: '400px',
    });
    this.onPopState = this.onPopState.bind(this);
  }

  connectedCallback() {
    const trigger = this.querySelector('.infinite-scroll-trigger');
    if (trigger) this.observer.observe(trigger);

    const button = this.querySelector('.infinite-scroll-button');
    if (button) {
      button.addEventListener('click', () => this.loadNext(trigger));
    }

    window.addEventListener('popstate', this.onPopState);
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this.onPopState);
  }

  onPopState() {
    window.location.reload();
  }

  onIntersect(entries) {
    const entry = entries[0];
    if (!entry.isIntersecting || this.loading) return;
    this.loadNext(entry.target);
  }

  async loadNext(trigger) {
    if (!trigger || this.loading) return;
    const nextUrl = trigger.dataset.nextUrl;
    if (!nextUrl) return;

    this.loading = true;
    this.observer.unobserve(trigger);
    this.toggleLoadingState(trigger, true);

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newGrid = html.querySelector('#product-grid');
      const newTrigger = html.querySelector('.infinite-scroll-trigger');
      const currentGrid = this.querySelector('#product-grid');

      if (newGrid && currentGrid) {
        Array.from(newGrid.children).forEach((child) => {
          currentGrid.appendChild(child);
        });
      }

      // Update URL so refresh/back reflects the current page
      const nextUrlObj = new URL(nextUrl, window.location.origin);
      window.history.pushState({}, '', nextUrlObj.pathname + nextUrlObj.search);

      trigger.remove();
      if (newTrigger) {
        this.appendChild(newTrigger);
        this.observer.observe(newTrigger);
        const newButton = newTrigger.querySelector('.infinite-scroll-button');
        if (newButton) {
          newButton.addEventListener('click', () => this.loadNext(newTrigger));
        }
      }
    } catch (e) {
      console.error('Infinite scroll fetch failed', e);
      this.toggleLoadingState(trigger, false);
      this.observer.observe(trigger); // retry on next intersect
    } finally {
      this.loading = false;
    }
  }

  toggleLoadingState(trigger, isLoading) {
    const button = trigger?.querySelector('.infinite-scroll-button');
    if (!button) return;
    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    button.textContent = isLoading
      ? button.dataset.loadingText
      : button.dataset.defaultText;
  }
}

customElements.define('infinite-scroll', InfiniteScroll);